/* Turns the reopen policy the server attached to each candidate into the two things the front desk
 * needs to know BEFORE submitting: does this need an approver, and what will it do to the room.
 *
 * The policy is decided server-side (FrontOffice::Rooms::ReopenPolicy) and acted on by the same
 * object, so what is shown here is what will happen — not a second copy of the rule that can drift.
 *
 * Both answers matter operationally. "Needs approval" means the request will sit in a queue until
 * someone decides it, so the FO may want to go and find a supervisor rather than assume it is done.
 * "Blocks the room" versus "returns the nights to eZee" is the difference between the room being
 * sellable again tonight and being deliberately held off the channel.
 */
export const reopenPolicyLines = (policy, t) => {
  if (!policy) return [];

  const lines = [];

  if (policy.auto_approve) {
    lines.push({ tone: "auto", text: t("reopen_policy_auto") });
  } else if (policy.queued_reason === "over_night_bound") {
    lines.push({
      tone: "approval",
      text: t("reopen_policy_over_bound")
        .replace("{nights}", policy.nights)
        .replace("{max}", policy.max_nights),
    });
  } else {
    lines.push({ tone: "approval", text: t("reopen_policy_needs_approval") });
  }

  lines.push({
    tone: "mode",
    text:
      policy.resolution_mode === "block_room"
        ? t("reopen_policy_mode_block")
        : t("reopen_policy_mode_open"),
  });

  return lines;
};

/* Plain-text form for the single-candidate confirm dialog, which takes a string body. */
export const reopenPolicyText = (policy, t) =>
  reopenPolicyLines(policy, t)
    .map((line) => line.text)
    .join(" ");
